import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { MappingBuilder } from "../MappingBuilder";

import { getMappingDataDefinition } from "../Testing/TestDataSetup";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const MappingEditorStories = [
    new StoryNode(
        () => {
            let definition = getMappingDataDefinition();
            return (
                <MappingBuilder
                    definition={definition}
                    mappingBuilderName={"Mapping Editor"}
                ></MappingBuilder>
            );
        },

        "Data Mapping Builder",
        "Default"
    ),
    new StoryNode(
        () => {
            let definition = getMappingDataDefinition();

            definition.getExecutionResult().fields.splice(0, 1);
            definition.mappingRules[1].targetPath = "totalWorkingHours";
            definition.mappingRules[1].mapping.value = 1200;
            definition.mappingRules[0].mapping.value = 1200;
            return (
                <MappingBuilder
                    definition={definition}
                    mappingBuilderName={"Mapping Editor"}
                ></MappingBuilder>
            );
        },

        "Data Mapping Builder",
        "Invalid"
    ),
];
